import {UserMenuWrapperDefaultBox} from "./user-menu-wrapper.default.box";

export const UserMenuWrapperBox = UserMenuWrapperDefaultBox;